import { Box } from "@mui/material";
import { Register } from "../../components/Auth/Register";

export function Signup(){
    return(
        <Box display={"flex"} justifyContent={"center"} alignItems={"center"} height={"100vh"} width={"100vw"}>
            <Register/>
        </Box>
    )
}